import { initializeSolarPanelsFunnelStepAction } from '@feh/solar-panels-store';
import type {
  SolarPanelsFunnelSettingsFields,
  SolarPanelsFunnelSettingsInterface,
  SolarPanelsFunnelStep,
} from '@innogy/feh/models';
import { mapUsageQuestionnaire } from '@innogy/feh/shared';
import { mapGenericModalProperties } from '@legacy/common-ui-shared';
import { GenericModalSources } from '@legacy/common-ui-shared-interfaces';

export function initializeSolarPanelsFunnelComponent(
  step: SolarPanelsFunnelStep,
  funnelSettings: SolarPanelsFunnelSettingsFields | null | undefined
) {
  return initializeSolarPanelsFunnelStepAction({
    step,
    funnelSettings: mapSolarPanelsFunnelSettingsFields(funnelSettings),
  });
}

export function mapSolarPanelsFunnelSettingsFields(
  funnelSettingsFromSitecore: SolarPanelsFunnelSettingsFields | null | undefined
): SolarPanelsFunnelSettingsInterface | undefined {
  if (!funnelSettingsFromSitecore?.fields) {
    return undefined;
  }

  const {
    StartPage,
    SuccessPage,
    SuitabilityCheckPage,
    OrderPage,
    ProductOverviewPage,
    ResultOverviewPage,
    GenericErrorModal,
    AddressNotFoundErrorModal,
    ShowProductPage,
    ShowResultOverviewPage,
    EnableSuitabilityCheckPage,
    HouseHasInsufficientRoofAreaPage,
    HouseIsMonumentPage,
    HouseNotFoundPage,
    HouseIsUnsuitablePage,
    UsageQuestionnaire,
  } = funnelSettingsFromSitecore.fields;

  return {
    id: funnelSettingsFromSitecore.id,
    startPage: StartPage?.value,
    houseNotFoundPage: HouseNotFoundPage?.value,
    houseIsUnsuitablePage: HouseIsUnsuitablePage?.value,
    houseIsMonumentPage: HouseIsMonumentPage?.value,
    houseHasInsufficientRoofAreaPage: HouseHasInsufficientRoofAreaPage?.value,
    suitabilityCheckPage: SuitabilityCheckPage?.value,
    productOverviewPage: ProductOverviewPage?.value,
    resultOverviewPage: ResultOverviewPage?.value,
    orderPage: OrderPage?.value,
    successPage: SuccessPage?.value,
    genericErrorModal: mapGenericModalProperties(
      GenericModalSources.GENERIC_ERROR_MODAL,
      GenericErrorModal?.fields
    ),
    addressNotFoundErrorModal: mapGenericModalProperties(
      GenericModalSources.ADDRESS_NOT_FOUND_ERROR_MODAL,
      AddressNotFoundErrorModal?.fields
    ),
    showSuitabilityCheckPage: EnableSuitabilityCheckPage?.value,
    showProductOverviewPage: ShowProductPage?.value,
    showResultOverviewPage: ShowResultOverviewPage?.value,
    usageWizard: mapUsageQuestionnaire(UsageQuestionnaire?.fields),
  };
}
